import  gql  from 'graphql-tag'

export const SHARE_STUDYDOCS_EMAIL = gql`mutation shareStudyDocsByEmail($input: ShareStudyDocsMutationInput!){
    shareStudyDocsByEmail(input: $input){
        errors{
            field
            messages
        }
    }
}`;